/**
 * This file is read-only, the const SDK_VERSION will be set to the package version
 * from package.json at build time, this action may or may not effect any changes
 * you make to this file. We therefore recommend that you refrain from editing this
 * file.
 */
export var SDK_VERSION = '2.9.1';
export var getSDKHeader = function (options) {
    var _a, _b;
    if (options === void 0) { options = {}; }
    var version = (_a = options.frameworkVersion) !== null && _a !== void 0 ? _a : SDK_VERSION;
    var framework = (_b = options.framework) !== null && _b !== void 0 ? _b : 'TypeScript';
    var headerValue = "".concat(framework, "/").concat(version);
    return ['Kinde-SDK', headerValue];
};
